(function () {
  var roots = document.querySelectorAll('[data-m1v2-train]');
  if (!roots.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    roots.forEach(function (el) {
      el.classList.add('is-in');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.32, rootMargin: '0px 0px -8% 0px' }
  );

  roots.forEach(function (el) {
    observer.observe(el);
  });
})();
